import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHash24 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.61844 1.75953C10.0274 1.82497 10.306 2.20959 10.2405 2.6186L9.45948 7.50012H15.9404L16.7594 2.38162C16.8248 1.97261 17.2094 1.69409 17.6184 1.75953C18.0274 1.82497 18.306 2.20959 18.2405 2.6186L17.4595 7.50012H21.2499C21.6642 7.50012 21.9999 7.83591 21.9999 8.25012C21.9999 8.66434 21.6642 9.00012 21.2499 9.00012H17.2195L16.2595 15.0001H20.2499C20.6641 15.0001 20.9999 15.3359 20.9999 15.7501C20.9999 16.1643 20.6641 16.5001 20.2499 16.5001H16.0195L15.2405 21.3686C15.1751 21.7776 14.7905 22.0561 14.3815 21.9907C13.9724 21.9252 13.6939 21.5406 13.7594 21.1316L14.5004 16.5001H8.01948L7.24052 21.3686C7.17508 21.7776 6.79046 22.0561 6.38145 21.9907C5.97244 21.9252 5.69392 21.5406 5.75936 21.1316L6.5004 16.5001H2.74512C2.3309 16.5001 1.99512 16.1643 1.99512 15.7501C1.99512 15.3359 2.3309 15.0001 2.74512 15.0001H6.7404L7.7004 9.00012H3.74994C3.33573 9.00012 2.99994 8.66434 2.99994 8.25012C2.99994 7.83591 3.33573 7.50012 3.74994 7.50012H7.9404L8.75936 2.38162C8.8248 1.97261 9.20942 1.69409 9.61844 1.75953ZM14.7404 15.0001L15.7004 9.00012H9.21948L8.25948 15.0001H14.7404Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgHash24;
